export default "\r\n> [!INFO]\r\n> \r\n> tags:  #🕸️/🟦  \r\n> References:  [[🧀Cooking]] \r\n> Links: \r\n\r\n![Youtube Link]() \r\n\r\nRecipe: ";